__turbopack_context__.v({
  "booleanForm": "building-blocks-module__GNYCla__booleanForm",
  "checked": "building-blocks-module__GNYCla__checked",
  "collapsed": "building-blocks-module__GNYCla__collapsed",
  "expandIcon": "building-blocks-module__GNYCla__expandIcon",
  "expandableForm": "building-blocks-module__GNYCla__expandableForm",
  "expanded": "building-blocks-module__GNYCla__expanded",
  "formBox": "building-blocks-module__GNYCla__formBox",
  "innerCircle": "building-blocks-module__GNYCla__innerCircle",
  "input": "building-blocks-module__GNYCla__input",
  "inputBigLabel": "building-blocks-module__GNYCla__inputBigLabel",
  "inputs": "building-blocks-module__GNYCla__inputs",
  "middleLine": "building-blocks-module__GNYCla__middleLine",
  "minus": "building-blocks-module__GNYCla__minus",
  "outerCircle": "building-blocks-module__GNYCla__outerCircle",
  "radio": "building-blocks-module__GNYCla__radio",
  "row": "building-blocks-module__GNYCla__row",
  "title": "building-blocks-module__GNYCla__title",
});
